
// Mirrors snippets/size-guide-scale.liquid. Returns '' when the product should
// show no size guide. Needs BOTH axes: productType (already indexed) and
// size_guide_info (must be added to the Meilisearch index).
// size_guide_info is translated, so markers are listed per language
var SG_UP_MARKERS = ["one size up", "sse gröss", "sse größ", "grösser", "größer"];
var SG_TTS_MARKERS = ["true to size", "grössengetreu", "größengetreu"];

function sizeGuideScaleFrom(sgInfo, productType) {
  var fitRaw = String(sgInfo || "").toLowerCase().trim();
  var typeRaw = String(productType || "").toLowerCase().trim();
  var gender = "";
  if (typeRaw === "men") gender = "men";
  else if (typeRaw === "kids") gender = "kids";
  else if (typeRaw === "slides" || typeRaw === "winter" || typeRaw === "sneakers") gender = "women";
  var fit = "";
  if (SG_UP_MARKERS.some(function (m) { return fitRaw.indexOf(m) !== -1; })) fit = "up";
  else if (SG_TTS_MARKERS.some(function (m) { return fitRaw.indexOf(m) !== -1; })) fit = "tts";
  if (gender && !fit) fit = "tts";
  if (gender === "kids" && fit === "up") fit = "tts";
  if (!gender || !fit) return "";
  return gender + "-" + fit;
}

/**
 * INUIKII – Meilisearch Collection Grid
 *
 * Expects: window.CollectionGridConfig (set by the section Liquid)
 */
(function () {
  "use strict";

  var CFG = window.CollectionGridConfig;
  if (!CFG || !CFG.meilisearch || !CFG.meilisearch.host) {
    console.warn("[Meilisearch] CollectionGridConfig missing – skipping init.");
    return;
  }

  var MS_HOST = CFG.meilisearch.host;
  var MS_KEY = CFG.meilisearch.apiKey;
  var MS_INDEX = CFG.meilisearch.index;
  var PER_PAGE = CFG.settings.productsPerPage || 14;
  var MONEY_FMT = CFG.settings.moneyFormat || "{{amount}} CHF";
  var COL_ID = CFG.collection.id || "";
  // Shopify's product ids for this collection (numeric strings only)
  var COL_PRODUCT_IDS = (CFG.collection.productIds || [])
    .map(String)
    .filter(function (id) { return /^\d+$/.test(id); });
  var COLOR_MAP = CFG.colorMap || {};
  // Colour labels are translated on /de ("Schwarz"), the facets are not ("Black"):
  // fall back to the metaobject handle, which is the English name.
  var COLOR_HANDLE_MAP = CFG.colorHandleMap || {};
  function colorHandle(name) {
    return String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  // Collection ids whose products must NOT show the colour name in the title
  // (Theme settings → AICO Product Display). Compared against hit.collections[].id.
  var HIDE_COLOR_COLLECTION_IDS = (CFG.hideColorCollectionIds || []).map(String);
  /* "Online exclusive" badge: product metafield aico_metafields.online_exclusive
   * (boolean), same check as snippets/online-exclusive-badge.liquid. Needs the
   * indexer to put the metafield on the hit, either in hit.metafields[] (like
   * size_guide_info) or as a top-level hit.online_exclusive. */
  var ONLINE_EXCLUSIVE_LABEL =
    (CFG.labels && CFG.labels.onlineExclusive) || "Online exclusive";
  function isTrueish(v) {
    return v === true || v === 1 || v === "true" || v === "1";
  }
  function isOnlineExclusive(hit) {
    if (isTrueish(hit.online_exclusive)) return true;
    var mfs = Array.isArray(hit.metafields) ? hit.metafields : [];
    for (var i = 0; i < mfs.length; i++) {
      var m = mfs[i];
      if (m && m.namespace === "aico_metafields" && m.key === "online_exclusive") {
        return isTrueish(m.value);
      }
    }
    return false;
  }
  function onlineExclusiveBadge(hit) {
    return isOnlineExclusive(hit)
      ? '<span class="online-exclusive-badge badge">' + esc(ONLINE_EXCLUSIVE_LABEL) + "</span>"
      : "";
  }
  /* "Bestseller" badge: product tag "Bestseller" (set in aico, synced to Shopify and
   * to hit.tags), same check as snippets/bestseller-badge.liquid. */
  var BESTSELLER_LABEL = (CFG.labels && CFG.labels.bestseller) || "Bestseller";
  /* Card button/label texts, translated by the section (CFG.labels). */
  var OUT_OF_STOCK_LABEL = (CFG.labels && CFG.labels.outOfStock) || "OUT OF STOCK";
  var NOTIFY_LABEL = (CFG.labels && CFG.labels.notify) || "NOTIFY";
  var SELECT_SIZE_LABEL = (CFG.labels && CFG.labels.selectSize) || "SELECT SIZE";
  function isBestseller(hit) {
    var tags = Array.isArray(hit.tags) ? hit.tags : [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === "bestseller") return true;
    }
    return false;
  }
  function bestsellerBadge(hit) {
    return isBestseller(hit)
      ? '<span class="bestseller-badge badge">' + esc(BESTSELLER_LABEL) + "</span>"
      : "";
  }
  /* Available cards: labels stacked top-left like the out-of-stock labels;
   * no wrapper when the product has none, so the card layout stays as before. */
  function cardLabels(hit) {
    var labels = onlineExclusiveBadge(hit) + bestsellerBadge(hit);
    return labels ? '<div class="custom-product-badge__labels">' + labels + "</div>" : "";
  }

  var LOCALE_PREFIX =
    CFG.localePrefix && String(CFG.localePrefix)
      ? String(CFG.localePrefix).replace(/\/$/, "")
      : "";

  var MARKET_HANDLE =
    CFG.market && CFG.market.handle ? CFG.market.handle : "ch";
  var MARKET_CURRENCY =
    CFG.market && CFG.market.currency ? CFG.market.currency : "CHF";

  /* ------------------------------------------------------------------
   * Shopify collection order ("Featured")
   *
   * The indexer writes one position field per collection, keyed by ID:
   *   collection 12345 -> position_in_collection_id_12345
   * It mirrors the collection's own product order, so for a collection set
   * to "Manual" in the admin this IS the merchandiser's drag & drop order.
   * The ID is used rather than the handle because collection.handle is
   * translated per locale (e.g. "winter" -> "inuikii-winter" on /de), while
   * the indexer only knows the base-language handle.
   *
   * Only fields listed in the index' sortableAttributes may be sorted on –
   * sorting on any other one makes Meilisearch reject the whole query and
   * the grid renders empty. That list is not readable with the public
   * search key, so we probe it once with a limit:0 query and fall back to
   * Name A-Z when the collection has no sortable position field.
   * The probe starts here, in parallel with the InstantSearch bundles, so
   * it costs no extra time before the first render.
   * ------------------------------------------------------------------ */
  var MANUAL_SORT_ATTR = COL_ID ? "position_in_collection_id_" + COL_ID : "";
  /** Set once the probe resolves: full sort value, or "" when unsupported. */
  var MANUAL_SORT = "";

  function probeManualSort() {
    if (!MANUAL_SORT_ATTR || typeof fetch !== "function") {
      return Promise.resolve("");
    }
    var sortValue = MS_INDEX + ":" + MANUAL_SORT_ATTR + ":asc";
    return fetch(
      MS_HOST + "/indexes/" + encodeURIComponent(MS_INDEX) + "/search",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + MS_KEY,
        },
        body: JSON.stringify({
          q: "",
          limit: 0,
          sort: [MANUAL_SORT_ATTR + ":asc"],
        }),
      },
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        // Meilisearch answers a rejected sort with { message, code: … }
        if (!json || json.code || !("hits" in json)) {
          console.warn(
            "[Collection] " +
            MANUAL_SORT_ATTR +
            " is not sortable – falling back to Name A-Z.",
          );
          return "";
        }
        return sortValue;
      })
      .catch(function (err) {
        console.warn("[Collection] Sort probe failed – falling back.", err);
        return "";
      });
  }

  var manualSortProbe = probeManualSort();

  var SIZE_ORDER = {
    xxs: 1,
    xs: 2,
    "xs/s": 3,
    s: 4,
    "s/m": 5,
    m: 6,
    "m/l": 7,
    l: 8,
    "l/xl": 9,
    xl: 10,
    "xl/xxl": 11,
    xxl: 12,
    xxxl: 13,
  };

  function sizeKey(val) {
    var v = val.toLowerCase().trim();
    if (v === "one size" || v === "onesize" || v === "os")
      return { group: 3, num: 0, order: 0 };
    var numMatch = v.match(/^(\d+)/);
    if (numMatch) return { group: 1, num: parseInt(numMatch[1], 10), order: 0 };
    if (SIZE_ORDER.hasOwnProperty(v))
      return { group: 2, num: 0, order: SIZE_ORDER[v] };
    return { group: 2, num: 0, order: 999 };
  }

  function sortSizeItems(items) {
    items.sort(function (a, b) {
      var ka = sizeKey(a.value);
      var kb = sizeKey(b.value);
      if (ka.group !== kb.group) return ka.group - kb.group;
      if (ka.group === 1) return ka.num - kb.num;
      if (ka.group === 2) return ka.order - kb.order;
      return 0;
    });
    return items;
  }

  function esc(s) {
    if (!s) return "";
    var d = document.createElement("div");
    d.textContent = s;
    return d.innerHTML;
  }

  function fmtPrice(amount) {
    if (amount == null || isNaN(Number(amount))) return "";
    // Prices from Meilisearch are already in decimal (e.g. 46.20), not cents
    var num = Number(amount);
    var formatted;
    if (MONEY_FMT.indexOf("amount_no_decimals_with_comma_separator") !== -1) {
      formatted = formatDecimal(num, 0, ".", ",");
    } else if (MONEY_FMT.indexOf("amount_with_comma_separator") !== -1) {
      formatted = formatDecimal(num, 2, ".", ",");
    } else if (MONEY_FMT.indexOf("amount_no_decimals") !== -1) {
      formatted = formatDecimal(num, 0, ",", ".");
    } else if (MONEY_FMT.indexOf("amount_with_apostrophe_separator") !== -1) {
      formatted = formatDecimal(num, 2, "'", ".");
    } else {
      formatted = formatDecimal(num, 2, ",", ".");
    }
    return MONEY_FMT.replace(/\{\{\s*[\w_]+\s*\}\}/g, formatted);
  }

  function formatDecimal(value, decimals, thousandsSep, decimalSep) {
    var parts = value.toFixed(decimals).split(".");
    if (thousandsSep && parts[0].length > 3) {
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    }
    return parts.join(decimalSep || ".");
  }

  function getSrc(img) {
    if (typeof img === "string") return img;
    return img && img.src ? img.src : "";
  }

  /**
   * @param {string} url
   * @param {number} width
   * @returns {string}
   */
  function shopifySizedUrl(url, width) {
    if (!url) return url;
    var sep = url.indexOf("?") !== -1 ? "&" : "?";
    return url + sep + "width=" + width;
  }

  /**
   * Builds a srcset string for Shopify CDN images
   * @param {string} url
   * @returns {string}
   */
  function shopifySrcset(url) {
    if (!url) return "";
    return [200, 360, 480, 540, 720, 900, 1080, 1440]
      .map(function (w) { return shopifySizedUrl(url, w) + " " + w + "w"; })
      .join(", ");
  }

  function parseImageFile(src) {
    if (!src) return null;
    var filename = src.split("/").pop().split("?")[0].toLowerCase();
    var baseName = filename.replace(/\.[^.]+$/, "");
    var parts = baseName.split("_");
    if (parts.length < 2) return null;
    // Shopify renames duplicate uploads by appending a UUID segment before the
    // extension (base_a.png -> base_a_dded9a18-....png). Strip it so the real
    // suffix (_a/_b/_1..N) is still recognised.
    if (
      parts.length > 2 &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(
        parts[parts.length - 1],
      )
    ) {
      parts.pop();
    }
    var suffix = parts[parts.length - 1];
    var firstChar = suffix.charAt(0);
    var firstDigit =
      firstChar >= "1" && firstChar <= "9" ? parseInt(firstChar, 10) : null;
    return {
      prefix: parts.slice(0, -1).join("_"),
      suffix: suffix,
      firstDigit: firstDigit,
    };
  }

  /**
   * Find _a/_b images from an image array prioritising variant SKU match.
   * Search order for _a: {sku}_a → {skuBase}_a → any _a. Same for _b.
   * Returns { img1, img2 } if an _a image is found, or null to use defaults.
   */
  function findABImages(allImages, variantSku) {
    if (!Array.isArray(allImages) || allImages.length === 0) return null;

    var skuFull = (variantSku || "").toLowerCase();
    var skuBase = skuFull.split("-")[0] || "";

    var imgA = null;
    var imgAPrefix = null;
    var imgAFallback = null;
    var imgAFallbackPrefix = null;

    for (var i = 0; i < allImages.length; i++) {
      var src = getSrc(allImages[i]);
      var parsed = parseImageFile(src);
      if (!parsed || (parsed.suffix !== "a" && parsed.suffix.charAt(0) !== "a"))
        continue;

      if (skuFull && parsed.prefix === skuFull) {
        imgA = src;
        imgAPrefix = parsed.prefix;
        break;
      }
      if (skuBase && parsed.prefix === skuBase && !imgA) {
        imgA = src;
        imgAPrefix = parsed.prefix;
      }
      if (!imgAFallback) {
        imgAFallback = src;
        imgAFallbackPrefix = parsed.prefix;
      }
    }

    if (!imgA && imgAFallback) {
      imgA = imgAFallback;
      imgAPrefix = imgAFallbackPrefix;
    }
    if (!imgA) return null;

    var imgB = null;
    for (var j = 0; j < allImages.length; j++) {
      var src2 = getSrc(allImages[j]);
      var parsed2 = parseImageFile(src2);
      if (
        !parsed2 ||
        (parsed2.suffix !== "b" && parsed2.suffix.charAt(0) !== "b")
      )
        continue;

      if (parsed2.prefix === imgAPrefix) {
        imgB = src2;
        break;
      }
    }

    return { img1: imgA, img2: imgB || "" };
  }

  /**
   * When _a/_b are not found, pick first two images by numeric order: use the first digit
   * after the underscore (so e.g. _35cf13782-... is treated as position 3). Matches product gallery logic.
   */
  function findFirstTwoImagesByNumericOrder(allImages, variantSku) {
    if (!Array.isArray(allImages) || allImages.length === 0) return null;
    var skuFull = (variantSku || "").toLowerCase();
    var skuBase = skuFull.split("-")[0] || "";
    var withIndex = [];
    for (var i = 0; i < allImages.length; i++) {
      var src = getSrc(allImages[i]);
      var parsed = parseImageFile(src);
      if (!parsed) continue;
      var prefixMatch =
        (skuFull && parsed.prefix === skuFull) ||
        (skuBase && parsed.prefix === skuBase);
      if (!prefixMatch) continue;
      var sortIndex = parsed.firstDigit != null ? parsed.firstDigit : 999;
      withIndex.push({ src: src, sortIndex: sortIndex });
    }
    withIndex.sort(function (a, b) {
      return a.sortIndex - b.sortIndex;
    });
    if (withIndex.length < 1) return null;
    return {
      img1: withIndex[0].src,
      img2: withIndex.length > 1 ? withIndex[1].src : "",
    };
  }

  /* ------------------------------------------------------------------
   * Default size for card links (client request 2026-09-03, refined the same
   * evening). Shopify's default variant is the first size (35), which shoppers
   * kept finding sold out on arrival. A card keeps its colour and picks:
   *   1. size 39 with real stock                      -> 39
   *   2. otherwise the smallest size with stock       -> that size
   *   3. nothing buyable in the colour, 39 exists     -> 39 ("39 - notify me")
   *   4. nothing buyable, no 39 in the range          -> Shopify's default
   * Buyability = availableForSale AND inventoryQuantity > 0, the same rule the
   * badge below and blocks/buy-buttons.liquid use. "Smallest" is numeric (a
   * few products list sizes out of order). Only the card href changes: the
   * NOTIFY link keeps the original variant id; the select-size modal reads
   * data-preferred-variant-id.
   * Same logic lives in search-meilisearch.js and predictive-search.js and,
   * for Liquid-rendered cards, in snippets/product-card-variant-url.liquid;
   * the PDP twin is snippets/variant-main-picker.liquid.
   * ------------------------------------------------------------------ */
  var PREFERRED_SIZE = "39";

  function preferredLinkVariantId(hit, fallbackVid) {
    var variants = Array.isArray(hit.variants) ? hit.variants : [];
    var preferred = null;
    var smallestBuyable = null;
    var smallestBuyableSize = 0;
    var firstBuyable = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v || !v.id) continue;
      var title = String(v.title);
      var buyable = !!v.availableForSale && Number(v.inventoryQuantity) > 0;
      if (title === PREFERRED_SIZE) preferred = { id: v.id, buyable: buyable };
      if (buyable) {
        if (firstBuyable === null) firstBuyable = v.id;
        var size = parseFloat(title);
        if (size > 0 && (smallestBuyable === null || size < smallestBuyableSize)) {
          smallestBuyable = v.id;
          smallestBuyableSize = size;
        }
      }
    }
    if (preferred && preferred.buyable) return preferred.id;
    if (smallestBuyable !== null) return smallestBuyable;
    if (firstBuyable !== null) return firstBuyable;
    if (preferred) return preferred.id;
    return fallbackVid;
  }

  function cardHTML(hit, idx) {
    var h = hit.handle || "";
    var title = esc(hit.title || "");
    var color = esc(hit.color_option || "");
    var hideColor =
      HIDE_COLOR_COLLECTION_IDS.length > 0 &&
      Array.isArray(hit.collections) &&
      hit.collections.some(function (c) {
        return c && HIDE_COLOR_COLLECTION_IDS.indexOf(String(c.id)) !== -1;
      });
    var pid = hit.product_parent_id || hit.id || "";
    var vid =
      hit.variant_id ||
      (hit.variants && hit.variants[0] && hit.variants[0].id) ||
      "";
    var sku = (hit.variants && hit.variants[0] && hit.variants[0].sku) || "";

    // Price & compare-at: use market-specific prices from the prices object
    var price = null;
    var cmp = 0;
    var priceFound = false;

    if (hit.prices && typeof hit.prices === "object") {
      var marketPrices = hit.prices[MARKET_HANDLE];
      if (marketPrices && marketPrices.hasOwnProperty("price")) {
        price = Number(marketPrices.price);
        cmp = Number(marketPrices.compareAtPrice) || 0;
        priceFound = true;
      } else if (hit.prices.hasOwnProperty("price")) {
        price = Number(hit.prices.price);
        cmp = Number(hit.prices.compareAtPrice) || 0;
        priceFound = true;
      }
    }

    if (!priceFound && hit.variants && hit.variants.length > 0) {
      price = 0;
      for (var vi = 0; vi < hit.variants.length; vi++) {
        var v = hit.variants[vi];
        var vp = Number(v.price) || 0;
        if (vp > 0 && (!price || vp < price)) price = vp;
        var vc = Number(v.compareAtPrice || v.compare_at_price) || 0;
        if (vc > cmp) cmp = vc;
      }
    }

    if (price === null) price = hit.min_price || 0;
    if (!cmp) cmp = hit.max_compare_at_price || 0;

    // Storewide sale (display-only): override price/compare-at for products in a
    // sale collection so cards mirror the real Shopify automatic discount.
    var onSale = false;
    if (window.StorewideSale && window.StorewideSale.enabled) {
      onSale = window.StorewideSale.isEligible(hit);
      if (onSale) {
        var _sw = window.StorewideSale.apply(price, cmp, hit);
        price = _sw.price;
        cmp = _sw.cmp;
      }
    }

    // Check if any variant is available (for the selected color if present)
    var avail = false;
    if (hit.variants && hit.variants.length > 0) {
      for (var ai = 0; ai < hit.variants.length; ai++) {
        if (hit.variants[ai].availableForSale) {
          avail = true;
          break;
        }
      }
    }
    if (!avail && hit.totalInventory > 0) avail = true;

    // Images: prefer variant_images.first/second when both exist (index provides this object), then _a/_b from media, then _1/_2 by SKU
    var variantFirstSrc =
      hit.variant_images &&
      hit.variant_images.first &&
      (hit.variant_images.first.src || hit.variant_images.first.url);
    var variantSecondSrc =
      hit.variant_images &&
      hit.variant_images.second &&
      (hit.variant_images.second.src || hit.variant_images.second.url);
    var useVariantImages = variantFirstSrc && variantSecondSrc;

    var allImages = hit.images || hit.product_images || hit.media || [];
    var abResult = findABImages(allImages, sku);
    var numericResult = !abResult
      ? findFirstTwoImagesByNumericOrder(allImages, sku)
      : null;

    var img1, img2;
    if (useVariantImages) {
      img1 = variantFirstSrc;
      img2 = variantSecondSrc;
    } else if (abResult) {
      img1 = abResult.img1;
      img2 = abResult.img2;
    } else if (numericResult) {
      img1 = numericResult.img1;
      img2 = numericResult.img2;
    } else {
      img1 = variantFirstSrc || "";
      img2 = variantSecondSrc || "";
    }

    var pUrl = (LOCALE_PREFIX ? LOCALE_PREFIX + "/" : "/") + "products/" + h;
    var sgInfo = hit.size_guide_info || (hit.metafields && hit.metafields.find(function (m) { return m.namespace === 'aico_metafields' && m.key === 'size_guide_info'; }) || {}).value || "";
    // Card href only - see preferredLinkVariantId(). `vid` stays the
    // colour's default variant for the notify link and the modal below.
    var linkVid = preferredLinkVariantId(hit, vid);
    var href = linkVid ? pUrl + "?variant=" + linkVid : pUrl;

    // Variant JSON for modal data-attributes
    var vJson = esc(
      JSON.stringify({
        id: vid,
        sku: sku,
        price: price,
        compare_at_price: cmp,
        available: avail,
      }),
    );

    /* Badge */
    // Buyability keys on actual stock: totalInventory 0 also covers untracked
    // inventory (which reports availableForSale=true) — treat it as out of stock.
    var hasStock = (Number(hit.totalInventory) || 0) > 0;
    var badge;
    if (!avail || !hasStock) {
      badge =
        '<div class="custom-product-badge">' +
        '<div class="custom-product-badge__labels">' +
        '<span class="badge">' + esc(OUT_OF_STOCK_LABEL) + '</span>' +
        onlineExclusiveBadge(hit) +
        bestsellerBadge(hit) +
        "</div>" +
        '<a href="' + pUrl + '?variant=' + vid + '&notify=true" class="notify-me-collection-btn">' + esc(NOTIFY_LABEL) + '</a>' +
        "</div>";
    } else {
      badge =
        '<div class="custom-product-badge">' +
        cardLabels(hit) +
        '<button class="custom-product-select-size-btn"' +
        ' data-product-id="' +
        pid +
        '"' +
        ' data-product-title="' +
        esc(hit.title) +
        '"' +
        ' data-product-handle="' +
        h +
        '"' +
        ' data-product-url="' +
        pUrl +
        '"' +
        ' data-product-image="' +
        img1 +
        '"' +
        ' data-product-price="' +
        fmtPrice(price) +
        '"' +
        ' data-product-compare-price="' +
        (cmp > price ? fmtPrice(cmp) : "") +
        '"' +
        ' data-variant-color="' +
        color +
        '"' +
        ' data-hide-color="' +
        (hideColor ? "1" : "") +
        '"' +
        ' data-storewide-sale="' +
        (onSale ? "1" : "") +
        '"' +
        " data-current-variant='" +
        vJson +
        "'" +
        ' data-preferred-variant-id="' +
        (linkVid !== vid ? linkVid : "") +
        '"' +
        ' data-size-guide-info="' +
        esc(sgInfo) +
        '"' +
        ' data-size-guide-scale="' +
        esc(sizeGuideScaleFrom(sgInfo, hit.productType)) +
        '"' +
        ">" + esc(SELECT_SIZE_LABEL) + "</button>" +
        "</div>";
    }

    var imgSizes = "(max-width: 749px) calc(50vw - 20px), (max-width: 1199px) calc(33vw - 20px), calc(25vw - 20px)";
    var aboveFold = idx < 8;
    var loadingAttr = aboveFold ? "eager" : "lazy";
    var fetchPriority = idx === 0 ? ' fetchpriority="high"' : "";
    var imgHtml;
    if (img1) {
      imgHtml =
        '<img src="' +
        shopifySizedUrl(img1, 540) +
        '" srcset="' +
        shopifySrcset(img1) +
        '" sizes="' +
        imgSizes +
        '" alt="' +
        title +
        '" width="100%" height="100%" loading="' +
        loadingAttr +
        '"' + fetchPriority + ' class="product-image-primary">';
    } else {
      imgHtml =
        '<div class="product-image-primary product-image-placeholder" style="background:#F8F8F8;display:flex;align-items:center;justify-content:center;">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="opacity:.3">' +
        '<path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"></path>' +
        '<polyline points="11 13 16 18 21 13 21 3 3 13 11 13"></polyline>' +
        "</svg>" +
        "</div>";
    }
    if (img2) {
      imgHtml +=
        '<img src="' +
        shopifySizedUrl(img2, 540) +
        '" srcset="' +
        shopifySrcset(img2) +
        '" sizes="' +
        imgSizes +
        '" alt="' +
        title +
        '" width="100%" height="100%" loading="lazy" class="product-image-secondary hidden--mobile">';
    }

    var priceHtml = "";
    if (cmp > price) {
      priceHtml +=
        '<span class="compare-at-price">' + fmtPrice(cmp) + "</span>";
    }
    priceHtml += '<span class="price">' + fmtPrice(price) + "</span>";

    return (
      '<div class="custom-product-card product_index-' +
      idx +
      '" data-sku="' +
      sku +
      '">' +
      badge +
      '<a href="' +
      href +
      '" class="custom-product-card-link">' +
      '<div class="custom-product-card-image">' +
      imgHtml +
      "</div>" +
      '<div class="custom-product-card-content">' +
      "<h3>" +
      title +
      (color && !hideColor ? " " + color : "") +
      "</h3>" +
      '<p class="custom-product-card-price-container">' +
      priceHtml +
      "</p>" +
      "</div>" +
      "</a>" +
      "</div>"
    );
  }

  var searchInitialized = false;

  function checkLibsAndInit() {
    if (searchInitialized) return;
    // instantMeiliSearch is exposed as a global by the UMD bundle
    var hasMeili =
      typeof instantMeiliSearch === "function" ||
      (window["@meilisearch/instant-meilisearch"] &&
        window["@meilisearch/instant-meilisearch"].instantMeiliSearch);
    var hasIS = typeof instantsearch !== "undefined";
    if (hasMeili && hasIS) {
      searchInitialized = true;
      // Wait for the sortable-attribute probe before building the widgets:
      // the default sort has to be known when InstantSearch is constructed.
      manualSortProbe.then(function (sortValue) {
        MANUAL_SORT = sortValue;
        initSearch();
      });
    }
  }

  // Poll until both libs are available (handles defer / async loading)
  var pollCount = 0;
  var pollId = setInterval(function () {
    pollCount++;
    checkLibsAndInit();
    if (searchInitialized || pollCount > 100) clearInterval(pollId);
  }, 100);

  // Also try immediately & on DOMContentLoaded / load
  checkLibsAndInit();
  document.addEventListener("DOMContentLoaded", checkLibsAndInit);
  window.addEventListener("load", checkLibsAndInit);

  function initSearch() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.has("page")) {
        url.searchParams.delete("page");
        var clean = url.pathname + (url.search || "") + (url.hash || "");
        window.history.replaceState({}, document.title, clean);
      }
    } catch (e) { }

    // Resolve the instantMeiliSearch function from whichever global is available
    var meiliFactory =
      typeof instantMeiliSearch === "function"
        ? instantMeiliSearch
        : window["@meilisearch/instant-meilisearch"].instantMeiliSearch;

    // Permanent filter: only products belonging to the current collection
    // Filter by collection ID (collections.id field in Meilisearch), OR'd with
    // the collection's product ids from Shopify (section Liquid): the index
    // documents lack some collections (parent category collections such as
    // Winter), which otherwise rendered as an empty grid.
    var collectionFilter = 'collections.id = "' + COL_ID + '"';
    if (COL_PRODUCT_IDS.length) {
      collectionFilter =
        "(" + collectionFilter +
        ' OR product_parent_id IN ["' + COL_PRODUCT_IDS.join('","') + '"])';
    }
    var baseFilter = COL_ID ? [collectionFilter] : [];

    var msClient = meiliFactory(MS_HOST, MS_KEY, {
      placeholderSearch: true,
      keepZeroFacets: false,
      finitePagination: false,
      meiliSearchParams: {
        filter: baseFilter,
      },
    });

    // Default sort: the collection's own order in Shopify ("Featured"), so a
    // collection set to Manual shows the merchandiser's order. Falls back to
    // Name A–Z when this collection has no sortable position field.
    var TITLE_SORT = MS_INDEX + ":title:asc";
    var DEFAULT_SORT = MANUAL_SORT || TITLE_SORT;

    var search = window.instantsearch({
      indexName: DEFAULT_SORT,
      searchClient: msClient.searchClient || msClient,
      routing: {
        stateMapping: {
          stateToRoute: function (uiState) {
            var idx = uiState[Object.keys(uiState)[0]] || {};
            var route = {};
            if (idx.refinementList) {
              var rl = idx.refinementList;
              if (rl.size_options && rl.size_options.length)
                route.size = rl.size_options;
              if (rl.color_group_facet && rl.color_group_facet.length)
                route.colorGroup = rl.color_group_facet;
              if (rl.color_option && rl.color_option.length)
                route.color = rl.color_option;
            }
            if (idx.sortBy && idx.sortBy !== DEFAULT_SORT) {
              // Strip index name from sort: "products_xxx:title:desc" → "title:desc"
              var sortValue = idx.sortBy.replace(MS_INDEX + ":", "");
              route.sort = sortValue;
            }
            // Do not sync page to URL: infinite scroll would show only that page on refresh
            return route;
          },
          routeToState: function (route) {
            var state = {};
            var refinementList = {};
            if (route.size) refinementList.size_options = [].concat(route.size);
            if (route.colorGroup)
              refinementList.color_group_facet = [].concat(route.colorGroup);
            if (route.color)
              refinementList.color_option = [].concat(route.color);
            if (Object.keys(refinementList).length)
              state.refinementList = refinementList;
            if (route.sort) {
              // Add index name back: "title:desc" → "products_xxx:title:desc"
              state.sortBy = MS_INDEX + ":" + route.sort;
            }
            // Ignore route.page so refresh always shows page 1 (infinite scroll)
            var uiState = {};
            uiState[DEFAULT_SORT] = state;
            return uiState;
          },
        },
      },
      initialUiState: {
        [DEFAULT_SORT]: {
          sortBy: DEFAULT_SORT,
        },
      },
    });

    var prevLen = 0;
    /** @type {Function|null} */
    var showMoreFn = null;
    var isLastPage = false;

    function renderHits(opts, firstRender) {
      var hits = opts.hits;
      var showMore = opts.showMore;
      var isLast = opts.isLastPage;
      var results = opts.results;
      var list = document.getElementById("ProductList");
      var sentinel = document.getElementById("ms-scroll-sentinel");
      var loader = document.getElementById("ms-load-more");

      showMoreFn = showMore;
      isLastPage = isLast;

      if (!list) return;

      if (firstRender) {
        if (hits.length === 0) return;
        var skels = list.querySelectorAll("[data-skeleton]");
        for (var s = 0; s < skels.length; s++) skels[s].remove();
      }

      var isFresh = hits.length <= PER_PAGE || hits.length < prevLen;

      if (isFresh) {
        console.log("[GW] Fresh render: " + hits.length + " cards");
        list.innerHTML = "";
        for (var i = 0; i < hits.length; i++) {
          list.insertAdjacentHTML("beforeend", cardHTML(hits[i], i));
        }
      } else if (hits.length > prevLen) {
        console.log(
          "[GW] Appending new cards: " + prevLen + " → " + hits.length,
        );
        for (var j = prevLen; j < hits.length; j++) {
          list.insertAdjacentHTML("beforeend", cardHTML(hits[j], j));
        }
      }

      prevLen = hits.length;

      if (sentinel) sentinel.style.display = isLast ? "none" : "block";
      if (loader) {
        loader.style.display = "none";
        var bar = document.getElementById("ms-loader-progress");
        if (bar) bar.classList.remove("is-loading");
      }

      /* Empty state: show message, hide teasers */
      var gridContainer = document.getElementById("ProductGridContainer");
      var teasers = gridContainer
        ? gridContainer.querySelectorAll(".teaser-card")
        : [];

      // Get total matching hits (not just current batch displayed)
      var totalHits = results && results.nbHits ? results.nbHits : hits.length;

      if (totalHits === 0) {
        // Show empty message (same markup as main-collection.liquid)
        list.innerHTML =
          '<div class="main-collection-grid__empty" style="grid-column:1/-1;">' +
          '<h2 class="main-collection-grid__empty-title h2">' +
          (CFG.noProductsFoundText || "No products found.") +
          "</h2>" +
          "<p>" +
          (CFG.useFewerFiltersHtml || "") +
          "</p>" +
          "</div>";
        // Add class so CSS can style the grid as empty
        if (gridContainer) gridContainer.classList.add("empty-collection-grid");
        // Hide teasers
        for (var t = 0; t < teasers.length; t++) {
          teasers[t].style.display = "none";
        }
      } else {
        // Products exist – remove empty class & show teasers if enough products
        if (gridContainer)
          gridContainer.classList.remove("empty-collection-grid");

        // Show teasers only if there are enough products to reach their position
        // Grid is 3 columns: position = (row - 1) × 3 + col
        for (var t2 = 0; t2 < teasers.length; t2++) {
          var teaser = teasers[t2];
          var row = parseInt(teaser.getAttribute("data-row-position")) || 0;
          var col = parseInt(teaser.getAttribute("data-col-position")) || 0;
          if (row && col) {
            var position = (row - 1) * 3 + col;
            // Show teaser only if total matching hits >= position
            teaser.style.display = totalHits >= position ? "" : "none";
          } else {
            teaser.style.display = "";
          }
        }
      }

      if (totalHits > 0) {
        console.log(
          "[Collection] Rendered " +
          list.querySelectorAll(".custom-product-card").length +
          " cards",
        );
      }
    }

    var customHits =
      window.instantsearch.connectors.connectInfiniteHits(renderHits);

    function initObserver() {
      var sentinel = document.getElementById("ms-scroll-sentinel");
      if (!sentinel) return;

      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting && showMoreFn && !isLastPage) {
              var loader = document.getElementById("ms-load-more");
              var bar = document.getElementById("ms-loader-progress");
              if (loader) loader.style.display = "flex";
              if (bar) bar.classList.add("is-loading");
              showMoreFn();
            }
          }
        },
        {
          rootMargin: "200px",
          threshold: 0.01,
        },
      ).observe(sentinel);
    }

    /* Show more / less toggle helper */
    var SHOW_MORE_SIZES = 7;
    var SHOW_MORE_COLORS = 10;
    var SHOW_MORE_ANIM_MS = 300;

    var ICON_PLUS_SVG =
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>' +
      '<path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>' +
      "</svg>";

    function addShowMoreToggle(container, limit, hasRefinedInHidden) {
      var items = container.querySelectorAll("li");
      if (items.length <= limit) {
        var existingWrap = container.parentNode.querySelector(".ms-show-more");
        if (existingWrap) existingWrap.remove();
        return false;
      }

      var shouldBeExpanded = hasRefinedInHidden || false;

      var existingWrap2 = container.parentNode.querySelector(".ms-show-more");
      var wrapper, btn, expanded, collapsedHeight, currentAnim;

      if (existingWrap2) {
        wrapper = existingWrap2;
        btn = wrapper.querySelector(".show-more__button");
        expanded = wrapper.getAttribute("data-expanded") === "true";
        var wasAutoExpanded =
          container.parentNode.getAttribute("data-auto-expanded") === "true";

        // Mark extra items first (they are all visible from fresh innerHTML)
        for (var i = limit; i < items.length; i++) {
          items[i].setAttribute("data-extra", "true");
        }

        if (shouldBeExpanded) {
          if (!expanded) {
            expanded = true;
            wrapper.setAttribute("data-expanded", "true");
            btn.setAttribute("aria-expanded", "true");
            container.parentNode.setAttribute("data-auto-expanded", "true");
          } else {
            if (wasAutoExpanded) {
              container.parentNode.setAttribute("data-auto-expanded", "true");
            }
          }
        } else {
          if (expanded && wasAutoExpanded) {
            var extras = container.querySelectorAll("[data-extra]");
            for (var k = 0; k < extras.length; k++) {
              extras[k].classList.add("hidden");
            }
            expanded = false;
            wrapper.setAttribute("data-expanded", "false");
            btn.setAttribute("aria-expanded", "false");
            container.parentNode.setAttribute("data-auto-expanded", "false");
          } else if (!expanded) {
            var extras = container.querySelectorAll("[data-extra]");
            for (var k = 0; k < extras.length; k++) {
              extras[k].classList.add("hidden");
            }
          }
        }

        return true;
      }

      if (!shouldBeExpanded) {
        for (var i = limit; i < items.length; i++) {
          items[i].classList.add("hidden");
          items[i].setAttribute("data-extra", "true");
        }
      } else {
        for (var i = limit; i < items.length; i++) {
          items[i].setAttribute("data-extra", "true");
        }
      }

      container.parentNode.setAttribute(
        "data-auto-expanded",
        shouldBeExpanded ? "true" : "false",
      );

      wrapper = document.createElement("div");
      wrapper.className = "ms-show-more";
      wrapper.setAttribute(
        "data-expanded",
        shouldBeExpanded ? "true" : "false",
      );

      btn = document.createElement("button");
      btn.className =
        "show-more__button button-unstyled button-unstyled--with-icon";
      btn.type = "button";
      btn.setAttribute("aria-expanded", shouldBeExpanded ? "true" : "false");
      btn.innerHTML =
        '<span class="svg-wrapper icon-plus">' +
        ICON_PLUS_SVG +
        "</span>" +
        '<span class="show-more__label show-more__label--more">' +
        (CFG.showMoreText || "Show more") +
        "</span>" +
        '<span class="show-more__label show-more__label--less">' +
        (CFG.showLessText || "Show less") +
        "</span>";

      wrapper.appendChild(btn);
      container.parentNode.appendChild(wrapper);

      collapsedHeight = 0;
      expanded = shouldBeExpanded;
      currentAnim = null;

      if (shouldBeExpanded) {
        var extras = container.querySelectorAll("[data-extra]");
        for (var j = 0; j < extras.length; j++) {
          extras[j].style.display = "none";
        }
        collapsedHeight = container.offsetHeight;
        for (var j = 0; j < extras.length; j++) {
          extras[j].style.removeProperty("display");
        }
      } else {
        collapsedHeight = container.offsetHeight;
      }

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        container.parentNode.setAttribute("data-auto-expanded", "false");

        var currentExpanded = wrapper.getAttribute("data-expanded") === "true";

        if (!currentExpanded) {
          var currentCollapsedHeight = container.offsetHeight;
          var extras = container.querySelectorAll("[data-extra]");
          for (var j = 0; j < extras.length; j++) {
            extras[j].classList.remove("hidden");
          }
          var expandedHeight = container.scrollHeight;

          container.style.overflow = "hidden";
          var anim = container.animate(
            { height: [currentCollapsedHeight + "px", expandedHeight + "px"] },
            { duration: SHOW_MORE_ANIM_MS, easing: "ease-in-out" },
          );
          if (anim) {
            anim.onfinish = function () {
              container.style.overflow = "";
              container.style.removeProperty("height");
            };
          }

          wrapper.setAttribute("data-expanded", "true");
          btn.setAttribute("aria-expanded", "true");
        } else {
          var startHeight = container.offsetHeight;

          var extras = container.querySelectorAll("[data-extra]");
          for (var m = 0; m < extras.length; m++) {
            extras[m].style.display = "none";
          }
          var targetCollapsedHeight = container.offsetHeight;
          for (var n = 0; n < extras.length; n++) {
            extras[n].style.removeProperty("display");
          }

          container.style.overflow = "hidden";
          var anim2 = container.animate(
            { height: [startHeight + "px", targetCollapsedHeight + "px"] },
            { duration: SHOW_MORE_ANIM_MS, easing: "ease-in-out" },
          );
          if (anim2) {
            anim2.onfinish = function () {
              var extras = container.querySelectorAll("[data-extra]");
              for (var k = 0; k < extras.length; k++) {
                extras[k].classList.add("hidden");
              }
              container.style.overflow = "";
              container.style.removeProperty("height");
            };
          }

          wrapper.setAttribute("data-expanded", "false");
          btn.setAttribute("aria-expanded", "false");
        }
      });

      return true;
    }

    /* Custom Size Filter (connectRefinementList) */
    var customSizeFilter =
      window.instantsearch.connectors.connectRefinementList(
        function renderSizeFilter(opts, isFirstRender) {
          var container = document.getElementById("ms-size-list");
          if (!container) return;
          var items = sortSizeItems(opts.items || []);
          container._refine = opts.refine;

          if (items.length === 0) {
            container.innerHTML =
              '<p class="filter-no-options">' +
              (CFG.filterNoOptionsText || "No options available") +
              "</p>";
            return;
          }

          var hasRefinedInHidden = false;
          for (var i = SHOW_MORE_SIZES; i < items.length; i++) {
            if (items[i].isRefined) {
              hasRefinedInHidden = true;
              break;
            }
          }

          var html = "";
          for (var si = 0; si < items.length; si++) {
            var item = items[si];
            html +=
              '<li><label class="variant-option__button-label">' +
              '<input type="checkbox" name="Size-' +
              esc(item.value) +
              '"' +
              ' value="' +
              esc(item.value) +
              '"' +
              ' aria-label="' +
              esc(item.label) +
              '"' +
              (item.isRefined ? " checked" : "") +
              ">" +
              '<span class="variant-option__button-label__text">' +
              esc(item.label) +
              "</span>" +
              "</label></li>";
          }
          container.innerHTML = html;
          addShowMoreToggle(container, SHOW_MORE_SIZES, hasRefinedInHidden);

          // Remove old listener if it exists to prevent duplicates
          if (container._changeHandler) {
            container.removeEventListener("change", container._changeHandler);
          }

          // Create and store the handler
          container._changeHandler = function (e) {
            if (e.target.tagName === "INPUT" && container._refine) {
              container._refine(e.target.value);
            }
          };
          container.addEventListener("change", container._changeHandler);
        },
      );

    /* Custom Color Group Filter (connectRefinementList)
     *  Facet value format: "order::name::hex"
     *  e.g. "2::Black/Dark Grey::#0a0a0b"
     */
    var customColorGroupFilter =
      window.instantsearch.connectors.connectRefinementList(
        function renderColorGroupFilter(opts, isFirstRender) {
          var container = document.getElementById("ms-color-group-list");
          if (!container) return;
          var items = opts.items || [];
          container._refine = opts.refine;

          if (items.length === 0) {
            container.innerHTML =
              '<p class="filter-no-options">' +
              (CFG.filterNoOptionsText || "No options available") +
              "</p>";
            return;
          }

          var parsed = [];
          for (var ci = 0; ci < items.length; ci++) {
            var item = items[ci];
            var parts = item.value.split("::");
            var order = parseInt(parts[0], 10) || 0;
            var name = parts[1] || item.value;
            var hex = parts[2] || "#ccc";
            parsed.push({
              order: order,
              name: name,
              hex: hex,
              value: item.value,
              isRefined: item.isRefined,
            });
          }
          parsed.sort(function (a, b) {
            return a.order - b.order;
          });

          var hasRefinedInHidden = false;
          for (var pi = SHOW_MORE_COLORS; pi < parsed.length; pi++) {
            if (parsed[pi].isRefined) {
              hasRefinedInHidden = true;
              break;
            }
          }

          var html = "";
          for (var pi = 0; pi < parsed.length; pi++) {
            var p = parsed[pi];
            html +=
              '<li><label class="color-option__button-label" title="' +
              esc(p.name) +
              '">' +
              '<input type="checkbox" name="color-group-' +
              esc(p.value) +
              '"' +
              ' value="' +
              esc(p.value) +
              '"' +
              ' aria-label="' +
              esc(p.name) +
              '"' +
              (p.isRefined ? " checked" : "") +
              ">" +
              '<span class="color-option__button-label__swatch" style="background-color: ' +
              esc(p.hex) +
              ';"></span>' +
              "</label></li>";
          }
          container.innerHTML = html;
          addShowMoreToggle(container, SHOW_MORE_COLORS, hasRefinedInHidden);

          // Remove old listener if it exists to prevent duplicates
          if (container._changeHandler) {
            container.removeEventListener("change", container._changeHandler);
          }

          // Create and store the handler
          container._changeHandler = function (e) {
            if (e.target.tagName === "INPUT" && container._refine) {
              container._refine(e.target.value);
            }
          };
          container.addEventListener("change", container._changeHandler);
        },
      );

    /* Custom Color Filter (connectRefinementList)
     *  Uses color_option field and maps to hex colors via COLOR_MAP
     */
    var customColorFilter =
      window.instantsearch.connectors.connectRefinementList(
        function renderColorFilter(opts, isFirstRender) {
          var container = document.getElementById("ms-color-list");
          if (!container) return;
          var items = opts.items || [];
          container._refine = opts.refine;

          if (items.length === 0) {
            container.innerHTML =
              '<p class="filter-no-options">' +
              (CFG.filterNoOptionsText || "No options available") +
              "</p>";
            return;
          }

          items.sort(function (a, b) {
            return a.label.localeCompare(b.label);
          });

          var hasRefinedInHidden = false;
          for (var i = SHOW_MORE_COLORS; i < items.length; i++) {
            if (items[i].isRefined) {
              hasRefinedInHidden = true;
              break;
            }
          }

          var html = "";
          for (var ci = 0; ci < items.length; ci++) {
            var item = items[ci];
            var colorName = item.label;

            // Try multiple matching strategies
            var hex =
              COLOR_MAP[colorName] || // Exact match
              COLOR_MAP[colorName.toLowerCase()] || // Lowercase
              COLOR_MAP[colorName.toUpperCase()] || // Uppercase
              COLOR_MAP[
              colorName.charAt(0).toUpperCase() +
              colorName.slice(1).toLowerCase()
              ] || // Title case
              COLOR_HANDLE_MAP[colorHandle(colorName)] ||
              "#cccccc"; // Fallback grey

            html +=
              '<li><label class="color-option__button-label" title="' +
              esc(colorName) +
              '">' +
              '<input type="checkbox" name="color-' +
              esc(item.value) +
              '"' +
              ' value="' +
              esc(item.value) +
              '"' +
              ' aria-label="' +
              esc(colorName) +
              '"' +
              (item.isRefined ? " checked" : "") +
              ">" +
              '<span class="color-option__button-label__swatch" style="background-color: ' +
              esc(hex) +
              ';"></span>' +
              "</label></li>";
          }
          container.innerHTML = html;
          addShowMoreToggle(container, SHOW_MORE_COLORS, hasRefinedInHidden);

          // Remove old listener if it exists to prevent duplicates
          if (container._changeHandler) {
            container.removeEventListener("change", container._changeHandler);
          }

          // Create and store the handler
          container._changeHandler = function (e) {
            if (e.target.tagName === "INPUT" && container._refine) {
              container._refine(e.target.value);
            }
          };
          container.addEventListener("change", container._changeHandler);
        },
      );

    /* Active filter badges (connectCurrentRefinements) */
    var CLEAR_ALL_TEXT = CFG.clearAllText || "Clear all";
    var REMOVE_TEXT = CFG.removeText || "Remove";

    var CLOSE_ICON_SVG =
      '<svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<g opacity="var(--close-icon-opacity)">' +
      '<path d="M6 1.5L1 6.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
      '<path d="M1 1.5L6 6.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
      "</g></svg>";

    // Friendly labels for facet attributes
    /** @type {Record<string, string>} */
    var FACET_LABELS = {
      size_options: CFG.filterSizeLabel || "Size",
      color_group_facet: CFG.filterColorGroupLabel || "Color group",
      color_option: CFG.filterColorLabel || "Color",
    };

    function parseColorGroupLabel(val) {
      // "2::Black/Dark Grey::#0a0a0b" → "Black/Dark Grey"
      var parts = val.split("::");
      return parts.length >= 2 ? parts[1] : val;
    }

    var customCurrentRefinements =
      window.instantsearch.connectors.connectCurrentRefinements(
        function renderCurrentRefinements(opts) {
          var container = document.getElementById("ms-active-filters");
          if (!container) return;

          var items = opts.items || [];
          if (items.length === 0) {
            container.innerHTML = "";
            return;
          }

          var html = "";
          for (var ri = 0; ri < items.length; ri++) {
            var refinement = items[ri];
            var attrLabel =
              FACET_LABELS[refinement.attribute] ||
              refinement.label ||
              refinement.attribute;
            var refinements = refinement.refinements || [];

            for (var rj = 0; rj < refinements.length; rj++) {
              var ref = refinements[rj];
              var displayLabel = ref.label;

              // Parse color_group_facet value for friendly label
              if (refinement.attribute === "color_group_facet") {
                displayLabel = parseColorGroupLabel(ref.label);
              }

              html +=
                '<span class="pills__pill pills__pill--desktop-small facets-remove__pill ms-active-pill" ' +
                'data-attribute="' +
                esc(refinement.attribute) +
                '" ' +
                'data-value="' +
                esc(ref.value) +
                '" ' +
                'role="button" tabindex="0">' +
                esc(attrLabel) +
                ": " +
                esc(displayLabel) +
                '<span class="svg-wrapper svg-wrapper--smaller">' +
                CLOSE_ICON_SVG +
                "</span>" +
                '<span class="visually-hidden">' +
                REMOVE_TEXT +
                "</span>" +
                "</span>";
            }
          }

          // Clear all button
          html +=
            '<button type="button" class="button-unstyled facets__clear-all-link facets__clear-all active ms-clear-all-btn">' +
            CLEAR_ALL_TEXT +
            "</button>";

          container.innerHTML = html;

          // Click handlers for individual pill removal
          var pills = container.querySelectorAll(".ms-active-pill");
          for (var pk = 0; pk < pills.length; pk++) {
            (function (pill) {
              pill.addEventListener("click", function () {
                var attr = pill.getAttribute("data-attribute");
                var val = pill.getAttribute("data-value");
                // Find matching refinement item and call its refine
                for (var fi = 0; fi < items.length; fi++) {
                  if (items[fi].attribute === attr) {
                    items[fi].refine(
                      items[fi].refinements.filter(function (r) {
                        return r.value === val;
                      })[0],
                    );
                    break;
                  }
                }
              });
            })(pills[pk]);
          }

          // Clear all handler
          var clearBtn = container.querySelector(".ms-clear-all-btn");
          if (clearBtn) {
            clearBtn.addEventListener("click", function () {
              for (var ci = 0; ci < items.length; ci++) {
                var refs = items[ci].refinements;
                for (var cj = refs.length - 1; cj >= 0; cj--) {
                  items[ci].refine(refs[cj]);
                }
              }
            });
          }
        },
      );

    /* Custom Sort By (connectSortBy) */
    var customSortBy = window.instantsearch.connectors.connectSortBy(
      function renderSortBy(opts, isFirstRender) {
        var container = document.getElementById("ms-sort-list");
        if (!container) return;
        var options = opts.options || [];
        var currentRefinement = opts.currentRefinement;
        container._refine = opts.refine;

        var html = "";
        for (var oi = 0; oi < options.length; oi++) {
          var opt = options[oi];
          var isChecked = opt.value === currentRefinement;
          html +=
            "<label>" +
            '<input type="radio" name="ms-sort-by" value="' +
            esc(opt.value) +
            '"' +
            (isChecked ? " checked" : "") +
            ">" +
            "<span>" +
            esc(opt.label) +
            "</span>" +
            "</label>";
        }
        container.innerHTML = html;

        // Remove old listener if it exists to prevent duplicates
        if (container._changeHandler) {
          container.removeEventListener("change", container._changeHandler);
        }

        // Create and store the handler
        container._changeHandler = function (e) {
          if (e.target.tagName === "INPUT" && container._refine) {
            container._refine(e.target.value);
          }
        };
        container.addEventListener("change", container._changeHandler);
      },
    );

    search.addWidgets([
      window.instantsearch.widgets.configure({
        hitsPerPage: PER_PAGE,
        filters: baseFilter.length > 0 ? baseFilter[0] : "",
      }),

      customHits({}),

      /* Active filter badges */
      customCurrentRefinements({}),

      /* Size facet */
      customSizeFilter({
        attribute: "size_options",
        limit: 50,
        sortBy: ["name:asc"],
      }),

      /* Color group facet */
      customColorGroupFilter({
        attribute: "color_group_facet",
        limit: 50,
        sortBy: ["name:asc"],
      }),

      /* Color facet */
      customColorFilter({
        attribute: "color_option",
        limit: 50,
        sortBy: ["name:asc"],
      }),

      /* Sort */
      customSortBy({
        items: (MANUAL_SORT
          ? [
            {
              label: CFG.sortFeatured || "Featured",
              value: MANUAL_SORT,
            },
          ]
          : []
        ).concat([
          {
            label: CFG.sortNameAsc || "Name A\u2013Z",
            value: TITLE_SORT,
          },
          {
            label: CFG.sortNameDesc || "Name Z\u2013A",
            value: MS_INDEX + ":title:desc",
          },
          {
            label: CFG.sortPriceAsc || "Price ascending",
            value: MS_INDEX + ":price_" + MARKET_HANDLE + ":asc",
          },
          {
            label: CFG.sortPriceDesc || "Price descending",
            value: MS_INDEX + ":price_" + MARKET_HANDLE + ":desc",
          },
        ]),
      }),
    ]);

    // Boot: start search + infinite scroll observer
    search.start();
    initObserver();
  } // end initSearch
})();
